import { render } from "./ArchivPage.vue?vue&type=template&id=9ce0e402"
import script from "./ArchivPage.vue?vue&type=script&lang=js"
export * from "./ArchivPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__